export abstract class AbstractPlayButtonService {
  public abstract playVideo(guid: string, isTrailer: boolean, title?: string, fromPlayer?: boolean): void;
}
